import { render, staticRenderFns } from "./DataQuality.vue?vue&type=template&id=8260a340&scoped=true&"
import script from "./DataQuality.vue?vue&type=script&lang=ts&"
export * from "./DataQuality.vue?vue&type=script&lang=ts&"
import style0 from "./DataQuality.vue?vue&type=style&index=0&id=8260a340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8260a340",
  null
  
)

export default component.exports